// import React from "react";
// import { FiAlertCircle, FiCheckCircle, FiInfo, FiLoader } from "react-icons/fi";

// const StatusAlert = ({ status }) => {
//   if (!status.message) return null;

//   console.log(status)

//   // Determine the status type based on the object properties
//   let statusType = "info"; // Default to info
//   if (status.loading) {
//     statusType = "loading";
//   } else if (status.success) {
//     statusType = "success";
//   } else if (status.isUnverified) {
//     statusType = "warn";
//   } else if (status.autoSent) {
//     statusType = "success";
//   } else {
//     statusType = "error";
//   }

//   const getAlertStyle = (type) => {
//     switch (type) {
//       case "success":
//         return {
//           backgroundColor: "#d4edda",
//           color: "#155724",
//           border: "1px solid #c3e6cb",
//         };
//       case "error":
//         return {
//           backgroundColor: "#f8d7da",
//           color: "#721c24",
//           border: "1px solid #f5c6cb",
//         };
//       case "warn":
//         return {
//           backgroundColor: "#fff3cd",
//           color: "#856404",
//           border: "1px solid #ffeeba",
//         };
//       case "loading":
//         return {
//           backgroundColor: "#cce5ff",
//           color: "#004085",
//           border: "1px solid #b8daff",
//         };
//       default:
//         return {};
//     }
//   };

//   const iconStyle = { marginRight: "12px", minWidth: 20, minHeight: 20 };

//   const alertStyle = {
//     display: "flex",
//     alignItems: "center",
//     padding: "10px",
//     borderRadius: "5px",
//     marginBottom: "10px",
//     fontSize: "16px",
//     width: "100%",
//     ...getAlertStyle(statusType),
//   };

//   const renderIcon = () => {
//     switch (statusType) {
//       case "success":
//         return <FiCheckCircle style={iconStyle} />;
//       case "error":
//         return <FiAlertCircle style={iconStyle} />;
//       case "warn":
//         return <FiInfo style={iconStyle} />;
//       case "loading":
//         return (
//           <FiLoader
//             style={{ ...iconStyle, animation: "spin 1s infinite linear" }}
//           />
//         );
//       default:
//         return null;
//     }
//   };

//   return (
//     <div style={alertStyle}>
//       {/* {renderIcon()} */}
//       {status.message}
//     </div>
//   );
// };

// export default StatusAlert;

import React from "react";

const StatusAlert = ({ status }) => {
  if (!status?.message) return null;

  // Prefer explicit type from backend
  let statusType = status.type || "info";

  const getAlertStyle = (type) => {
    switch (type) {
      case "success":
        return {
          backgroundColor: "#d4edda",
          color: "#155724",
          border: "1px solid #c3e6cb",
        };
      case "error":
        return {
          backgroundColor: "#f8d7da",
          color: "#721c24",
          border: "1px solid #f5c6cb",
        };
      case "warn":
        return {
          backgroundColor: "#fff3cd",
          color: "#856404",
          border: "1px solid #ffeeba",
        };
      case "loading":
        return {
          backgroundColor: "#cce5ff",
          color: "#004085",
          border: "1px solid #b8daff",
        };
      default:
        return {
          backgroundColor: "#f1f1f1",
          color: "#333",
          border: "1px solid #ddd",
        };
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: "10px 12px",
        borderRadius: "6px",
        marginBottom: "10px",
        fontSize: "14px",
        width: "100%",
        ...getAlertStyle(statusType),
      }}
    >
      {status.message}
    </div>
  );
};

export default StatusAlert;
